'use strict'

import ngResource from 'angular-resource';

class MailTextService {
    constructor($resource) {
        'ngInject';
        this.oem_api = $resource(
            '/api/oem/mail_text', {},
            { 
                index:  { method: 'GET',  isArray: false },
                create: { method: 'POST', isArray: false }
            }
        );
    }
}

export default angular.module('leptonApp.MailTextService', ['ngResource'])
    .service('MailTextService', ['$resource', MailTextService])
    .name;



// WEBPACK FOOTER //
// ./public/dev/components/api/mail_text/mail_text.service.js